import { render, staticRenderFns } from "./SearchSimple.vue?vue&type=template&id=123fcd11&"
import script from "./SearchSimple.vue?vue&type=script&lang=ts&"
export * from "./SearchSimple.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports